'use client';

import React from 'react';

import {
    Align,
    Button,
    ButtonVariant,
    DirectionEnum,
    FlexBox,
    FlexItem,
    Icon,
    IconName,
    IconSize,
    Modal,
    ModalBody,
    ModalFooter,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

interface PriceGuaranteeModalProps {
    isOpen: boolean;
    handleClose: () => void;
}

export function PriceGuaranteeModal({ isOpen, handleClose }: Readonly<PriceGuaranteeModalProps>) {
    return (
        <Modal active={isOpen} onClose={handleClose} title='Votre smartphone certifié moins cher ou remboursé'>
            <ModalBody>
                <FlexBox direction={DirectionEnum.ROW} align={Align.CENTER}>
                    <FlexItem narrow>
                        <Icon
                            name={IconName.MOBILE}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </FlexItem>
                    <FlexItem>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Vous achetez votre smartphone
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Avec ou sans forfait, sur notre site, en boutique ou par téléphone.
                        </Text>
                    </FlexItem>
                </FlexBox>
                <FlexBox direction={DirectionEnum.ROW} align={Align.CENTER}>
                    <FlexItem narrow>
                        <Icon
                            name={IconName.MOBILE_EURO}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </FlexItem>
                    <FlexItem>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Vous repérez un meilleur prix
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Une capture d&apos;écran ou une photo suffit pour nous apporter la preuve.
                        </Text>
                    </FlexItem>
                </FlexBox>
                <FlexBox direction={DirectionEnum.ROW} align={Align.CENTER}>
                    <FlexItem narrow>
                        <Icon
                            name={IconName.FILE_ATTACHED}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </FlexItem>
                    <FlexItem>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Vous déposez votre demande en ligne
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Via notre formulaire en ligne avec cette preuve, votre facture et votre RIB.
                        </Text>
                    </FlexItem>
                </FlexBox>
                <FlexBox direction={DirectionEnum.COLUMN}>
                    <FlexItem>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Bonne nouvelle&nbsp;! On vous rembourse la différence sur votre compte bancaire&nbsp;🤩
                        </Text>
                        <Text level={TextLevels.TWO}>(Montant du remboursement entre 5€ et 150€)</Text>
                    </FlexItem>
                </FlexBox>
            </ModalBody>
            <ModalFooter>
                <Button variant={ButtonVariant.PRIMARY} onClick={handleClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}
